/*
This file is to store all events in a constant property variable.
Author  : Dipjay Datta<dipjay.d@vcloudx.com>
Company : Vcloudx Infotech
Date	: 27/11/2017 05:14 PM
*/

const VcxEventProperties = {};
VcxEventProperties.SocketEvent = {};
VcxEventProperties.RoomEvent = {};
VcxEventProperties.UserEvent = {};
VcxEventProperties.StreamEvent = {};

VcxEventProperties.SocketEvent.onAddStream = 'onAddStream';
VcxEventProperties.SocketEvent.onRemoveTrack = 'onRemoveTrack';
VcxEventProperties.SocketEvent.media_engine_connecting = 'media_engine_connecting';
VcxEventProperties.SocketEvent.signaling_message_peer = 'signaling_message_peer';
VcxEventProperties.SocketEvent.publish_me = 'publish_me';
VcxEventProperties.SocketEvent.unpublish_me = 'unpublish_me';
VcxEventProperties.SocketEvent.onBandwidthAlert = 'onBandwidthAlert';
VcxEventProperties.SocketEvent.onSelfBandwidthAlert = 'onSelfBandwidthAlert';
VcxEventProperties.SocketEvent.onDataStream = 'onDataStream';
VcxEventProperties.SocketEvent.onUpdateAttributeStream = 'onUpdateAttributeStream';
VcxEventProperties.SocketEvent.onRemoveStream = 'onRemoveStream';
VcxEventProperties.SocketEvent.disconnect = 'disconnect';
VcxEventProperties.SocketEvent.connection_failed = 'connection_failed';
VcxEventProperties.SocketEvent.error = 'error';
VcxEventProperties.SocketEvent.connect_error = 'connect_error';
VcxEventProperties.SocketEvent.connect_timeout = 'connect_timeout';
VcxEventProperties.SocketEvent.reconnecting = 'reconnecting';
VcxEventProperties.SocketEvent.reconnect = 'reconnect';
VcxEventProperties.SocketEvent.reconnected = 'reconnected';
VcxEventProperties.SocketEvent.reconnect_attempt = 'reconnect_attempt';
VcxEventProperties.SocketEvent.reconnect_error = 'reconnect_error';
VcxEventProperties.SocketEvent.reconnect_failed = 'reconnect_failed';
VcxEventProperties.SocketEvent.user_connected = 'user-connected';
VcxEventProperties.SocketEvent.user_disconnected = 'user-disconnected';
VcxEventProperties.SocketEvent.user_subscribed = 'user-subscribed';
VcxEventProperties.SocketEvent.user_unsubscribed = 'user-unsubscribed';
VcxEventProperties.SocketEvent.dial_state_events = 'dialStateEvents';
VcxEventProperties.RoomEvent.user_role_changed = 'userRoleChanged';
// manu stats
VcxEventProperties.SocketEvent.onStatSubscription = 'onStatSubscription';
VcxEventProperties.SocketEvent.onStreamingNotification = 'onStreamingNotification';
VcxEventProperties.SocketEvent.onLiveRecordingNotification = 'onLiveRecordingNotification';
// end manu stats
VcxEventProperties.SocketEvent.data_stream_room = 'onDataStreamToRoom';
VcxEventProperties.RoomEvent.onStreamingNotification = 'onStreamingNotification';
VcxEventProperties.RoomEvent.onLiveRecordingNotification = 'onLiveRecordingNotification';

VcxEventProperties.UserEvent.user_awaited = 'user-awaited';
VcxEventProperties.UserEvent.user_joined = 'user-joined';

VcxEventProperties.RoomEvent.room_connected = 'room-connected';
VcxEventProperties.RoomEvent.room_disconnected = 'room-disconnected';
VcxEventProperties.RoomEvent.room_awaited = 'room-awaited';
VcxEventProperties.RoomEvent.room_record_on = 'room-record-on';
VcxEventProperties.RoomEvent.room_record_off = 'room-record-off';
VcxEventProperties.RoomEvent.new_active_talker = 'active-talkers-updated';
VcxEventProperties.RoomEvent.hard_mute_audio = 'hardmute-user-audio';
VcxEventProperties.RoomEvent.hard_unmute_audio = 'hardunmute-user-audio';
VcxEventProperties.RoomEvent.hard_mute_video = 'hardmute-user-video';
VcxEventProperties.RoomEvent.hard_unmute_video = 'hardunmute-user-video';
VcxEventProperties.RoomEvent.get_active_talker = 'getNumberOfTalker';
VcxEventProperties.RoomEvent.set_active_talker = 'setNumberOfTalker';
VcxEventProperties.RoomEvent.get_active_max_talker = 'getMaxNumberOfTalker';
VcxEventProperties.RoomEvent.set_adavanced_options = 'setAdvancedOptions';
VcxEventProperties.RoomEvent.get_adavanced_options = 'getAdvancedOptions';
VcxEventProperties.RoomEvent.client_stats = 'clientStats';
VcxEventProperties.RoomEvent.switch_user_role = 'switchUserRole';
VcxEventProperties.RoomEvent.hard_unmute_video = 'hardunmute-user-video';
VcxEventProperties.RoomEvent.share_started = 'shareStarted';
VcxEventProperties.RoomEvent.share_stopped = 'shareStopped';
VcxEventProperties.RoomEvent.share_state_events = 'shareStateEvents';
VcxEventProperties.RoomEvent.extend_conference_duration = 'extendConferenceDuration';
VcxEventProperties.RoomEvent.lock_room = 'lockRoom';
VcxEventProperties.RoomEvent.drop = 'drop';
VcxEventProperties.RoomEvent.subscriber_video_mute = 'subscriber-video-mute';
VcxEventProperties.RoomEvent.switch_codec = 'switch-publish-media-codec';
VcxEventProperties.RoomEvent.canvas_started = 'canvasStarted';
VcxEventProperties.RoomEvent.canvas_stopped = 'canvasStopped';
VcxEventProperties.RoomEvent.canvas_state_events = 'canvasStateEvents';
//breakout room events
VcxEventProperties.RoomEvent.invite_breakout_room = 'invite-breakout-room';
VcxEventProperties.RoomEvent.user_joined_breakout_room = 'user-joined-breakout-room';
VcxEventProperties.RoomEvent.user_left_breakout_room = 'breakout-user-disconnected';
VcxEventProperties.RoomEvent.breakout_room_destroyed = 'breakout-room-destroyed';

VcxEventProperties.RoomEvent.generic_events = 'genericEvents';
VcxEventProperties.RoomEvent.network_reconnected = 'network-reconnected';
VcxEventProperties.RoomEvent.network_disconnected = 'network-disconnected';
VcxEventProperties.RoomEvent.network_reconnectiontimeout = 'network-reconnect-timeout';
VcxEventProperties.RoomEvent.network_reconnectfailed = 'network-reconnect-failed';
// file sharing room level events
// to do remove unused file sharing events
VcxEventProperties.RoomEvent.fs_upload_started = 'fs-upload-started';
VcxEventProperties.RoomEvent.fs_file_uploaded = 'fs-file-uploaded';
VcxEventProperties.RoomEvent.fs_file_uploaded = 'fs-file-available';
VcxEventProperties.RoomEvent.fs_download_started = 'fs-download-started';
VcxEventProperties.RoomEvent.fs_file_downloaded = 'fs-file-downloaded';
VcxEventProperties.RoomEvent.fs_file_downloaded = 'fs-upload-success';
VcxEventProperties.RoomEvent.fs_file_upload_result = 'fs-upload-result';
VcxEventProperties.RoomEvent.fs_file_download_result = 'fs-download-result';


VcxEventProperties.SocketEvent.floor_management_events = 'floorManagementEvents';
VcxEventProperties.SocketEvent.room_management_events = 'roomManagementEvents';
VcxEventProperties.UserEvent.user_audio_muted = 'user-audio-muted';
VcxEventProperties.UserEvent.user_audio_unmuted = 'user-audio-unmuted';
VcxEventProperties.UserEvent.user_video_muted = 'user-video-muted';
VcxEventProperties.UserEvent.user_video_unmuted = 'user-video-unmuted';

VcxEventProperties.SocketEvent.hard_mute = 'hardMute';
VcxEventProperties.SocketEvent.hard_mute_room = 'room-muted';
VcxEventProperties.SocketEvent.hard_unmute_room = 'room-unmuted';


VcxEventProperties.SocketEvent.switched_room = 'roomSwitched';

VcxEventProperties.constant = {};
VcxEventProperties.constant.H264_CODEC = 'H264_AND_OPUS';
VcxEventProperties.constant.default = 'default';

VcxEventProperties.constant.SAFARI_VERSION_NOT_SUPPORTING_VP8 = '12.0';
VcxEventProperties.constant.SAFARI_VERSION_SUPPORTING_VP8 = '12.1';
VcxEventProperties.constant.FIREFOX_VERSION_VIDEO_MUTE_SUPPORT = '60.0';
VcxEventProperties.constant.CHROME_VERSION_SCREEN_SHARE_WITHOUT_EXTN_SUPPORT = '72.0';
VcxEventProperties.constant.FIREFOX_VERSION_SCREEN_SHARE_WITHOUT_EXTN_SUPPORT = '66.0';
VcxEventProperties.constant.SAFARI_VERSION_SCREEN_SHARE_SUPPORT = '13.0.0';
VcxEventProperties.constant.FIREFOX_VERSION_SENDER_ENCODINGS_PARAM_SUPPORT = '64.0';
VcxEventProperties.constant.SAFARI_VERSION_SENDER_ENCODINGS_PARAM_SUPPORT = '13.1.0';

export default VcxEventProperties;



//////////////////
// WEBPACK FOOTER
// ./src/vcxEventProperties.js
// module id = 6
// module chunks = 0